import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { 
  ODataClient,
  ODataEntityService, 
  ODataEntity, 
  ODataEntities, 
  ODataProperty, 
  EntityKey,
  Duration,
  ODataEntityResource,
  ODataEntitySetResource,
  ODataNavigationPropertyResource,
  ODataActionResource,
  ODataFunctionResource,
  HttpOptions
} from 'angular-odata';

//#region ODataApi Imports
import { Artikel } from '../entities/artikel.entity';
import { ProduktTypAttribute } from '../entities/produkte/produkttypattribute.entity';
import { ProduktTypGroup } from '../entities/produkte/produkttypgroup.entity';
import { ProduktTyp } from '../entities/produkte/produkttyp.entity';
import { Status } from '../entities/settings/status.entity';
import { StatusType } from '../entities/settings/statustype.entity';
//#endregion

@Injectable()
export class ProduktTypService extends ODataEntityService<ProduktTyp> {
  constructor(protected client: ODataClient) {
    super(client, 'ProduktTyp', 'entities.produkte.ProduktTyp');
  }

  
  
  //#region ODataApi Actions
  //#endregion
  //#region ODataApi Functions
  //#endregion
  //#region ODataApi Navigations
  public articles(entity: EntityKey<ProduktTyp>): ODataNavigationPropertyResource<Artikel> {
    return this.entity(entity).navigationProperty<Artikel>('articles');
  }
  public attributes(entity: EntityKey<ProduktTyp>): ODataNavigationPropertyResource<ProduktTypAttribute> {
    return this.entity(entity).navigationProperty<ProduktTypAttribute>('attributes');
  }
  public produktTypGroups(entity: EntityKey<ProduktTyp>): ODataNavigationPropertyResource<ProduktTypGroup> {
    return this.entity(entity).navigationProperty<ProduktTypGroup>('produktTypGroups');
  }
  public status(entity: EntityKey<ProduktTyp>): ODataNavigationPropertyResource<Status> {
    return this.entity(entity).navigationProperty<Status>('status');
  }
  public statusType(entity: EntityKey<ProduktTyp>): ODataNavigationPropertyResource<StatusType> {
    return this.entity(entity).navigationProperty<StatusType>('statusType');
  }
  //#endregion
}
